import { axiosInstance } from "../utils/axios";
import { getAuthHeader } from "../utils/authTools";

export const createUser = async (request) => {
    let response = await axiosInstance.post(
        `/auth/signup`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const signIn = async (request) => {
    let response = await axiosInstance.post(
        `/auth/signInWeb`,
        request
    );
    return response.data;
};

export const verifyTokenAndGetDetails = async () => {
    let response = await axiosInstance.get(
        `/auth/verifytokeWeb`,
        getAuthHeader()
    );
    return response.data;
};

export const twoFactorAuthentication = async () => {
    let response = await axiosInstance.post(
        `/auth/2fa/generate`,
    );
    return response.data;
}

export const verifyTwoFactorCodeWithSecret = async (request) => {
    let response = await axiosInstance.post(
        `auth/2fa/enable`,
        request,
    );
    return response.data;
}

export const verifyTwoFactorCodeWithoutSecret = async (request) => {
    let response = await axiosInstance.post(
        `auth/2fa/checkToken`,
        request,
    );
    return response.data;
}
